import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import POauthProvider from '@peloton/auth/OauthProvider';
import { toOauthConfig, OAUTH_REDIRECT_URI } from '@webtv/env';
import { captureException } from '@webtv/error-reporting-v2';
import { jsx as _jsx } from "react/jsx-runtime";

var OauthProvider = function OauthProvider(_ref) {
  var oauthEnv = _ref.oauthEnv,
      children = _ref.children;
  return /*#__PURE__*/_jsx(POauthProvider, _objectSpread(_objectSpread({}, toOauthConfig(oauthEnv)), {}, {
    advancedOptions: {
      defaultScope: 'openid offline_access'
    },
    redirect_uri: OAUTH_REDIRECT_URI,
    onErrorCallback: function onErrorCallback(e, action) {
      return captureException(e, {
        type: 'OauthProvider',
        action: action
      });
    },
    children: children
  }));
};

export default OauthProvider;